import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-table/style/index.js